
import { computed, defineComponent, ref } from "vue";
import ReservationCard from "../interfaces/Reservation/ReservationCard.interface";
import { useStore } from "../store";
export default defineComponent({
  name: "ReservationCard",
  props: {
    reservation: {
      required: true,
      type: Object as () => ReservationCard,
    },
  },
  setup(props, { emit }) {
    const store = useStore();

    const startTimeString = computed(() => {
      return calcTimeString(
        props.reservation.startDate,
        props.reservation.startTime
      );
    });
    const endTimeString = computed(() => {
      return calcTimeString(
        props.reservation.endDate,
        props.reservation.endTime
      );
    });

    const sectionsSortedAlphabetically = ref([] as string[]);
    props.reservation.sections.forEach((section) => {
      sectionsSortedAlphabetically.value.push(section.sectionName);
    });
    sectionsSortedAlphabetically.value.sort((a, b) => {
      if (a.toLowerCase() < b.toLowerCase()) {
        return -1;
      }
      if (a.toLowerCase() > b.toLowerCase()) {
        return 1;
      }
      return 0;
    });

    const calcTimeString = (date: string, time: string) => {
      return time === "00:00" ? date : `${date} ${time}`;
    };

    const deleteReservation = async (id: number) => {
      if (window.confirm("Are you sure you want to delete the reservation?")) {
        if (
          await store.dispatch(
            "deleteReservation",
            props.reservation.reservationId
          )
        ) {
          emit("reload", id);
        }
      }
    };
    return {
      startTimeString,
      endTimeString,
      sectionsSortedAlphabetically,
      deleteReservation,
    };
  },
});
